// frontend/src/services/kitchenHistory.ts
export type HistoryItem = {
  id: number;
  number: string;
  table?: string | number | null;
  items: Array<{ name: string; qty: number; note?: string | null; modifiers?: string[] }>;
  at: number; // epoch s
};

const KEY = "kitchen.ready.history";
const MAX_STORE = 100; // drži do 100 lokalno

export function appendReadyHistory(entry: HistoryItem) {
  const list = readAll();
  list.unshift(entry);
  // dedup po id-u, zadrži noviji
  const seen = new Set<number>();
  const dedup = list.filter(x => (seen.has(x.id) ? false : (seen.add(x.id), true)));
  save(dedup.slice(0, MAX_STORE));
}

export function getRecent(limit = 10): HistoryItem[] {
  return readAll().slice(0, limit);
}

export function clearHistory() {
  localStorage.removeItem(KEY);
}

function readAll(): HistoryItem[] {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    if (Array.isArray(arr)) return arr;
  } catch {}
  return [];
}

function save(arr: HistoryItem[]) {
  try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch {}
}
